import { render } from "./Testimonie.vue?vue&type=template&id=fd12adfa"
import script from "./Testimonie.vue?vue&type=script&lang=js"
export * from "./Testimonie.vue?vue&type=script&lang=js"

import exportComponent from "/Users/santoshmaharjan/Documents/htdocs/helmetsnepal-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__